import { ApiService } from './../core/api-service/api.service';
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccountingService {

  baseUrl = environment.baseUrl;
  baseUrlForFleetAssist = environment.baseUrlForFleetAssist;
  baseUrlForAccounting = environment.baseUrlForAccounting;

  constructor(private http: HttpClient, private apiService: ApiService) { }

  getAccountingActiveWOsByCustomer(data): Observable<any> {
    return this.http.post(this.baseUrl + "GetAcctWOsByCustomer", data);
  }

  getActiveWOsByCustomer(data): Observable<any> {
    return this.http.post(this.baseUrl + "GetActiveWOsByCustomer", data);
  }

  getAccountingActiveWOsByCustomerWithLimit(data): Observable<any> {
    return this.http.post(this.baseUrl + "GetAcctWOsByCustomerWithLimit", data);
  }

  getActiveWOsByCustomerWithLimit(data): Observable<any> {
    return this.http.post(this.baseUrl + "GetActiveWOsByCustomerWithLimit", data);
  }

  GetWOsLastPaidByCustomer(data): Observable<any> {
    return this.http.post(this.baseUrl + "GetWOsLastPaidByCustomer", data);
  }

  // FOR ADDING ROWS IN DATA_TABLE
  getAddRow(value) {
    return this.apiService.get(this.baseUrlForFleetAssist + 'api/fleetAssist/getWORODetails/' + value);
  }

  updateWoDetailsOnInvoice(data): Observable<any> {
    return this.http.post(this.baseUrl + "updateWOData", data);
  }

  GetAcctTotalUnpaidOverdue(customerKey): Observable<any> {
    return this.http.get(this.baseUrl + "GetAcctTotalUnpaidOverdue/" + customerKey);
  }

  getEstimatedUnbilledByCustomer(customerKey): Observable<any> {
    return this.http.get(this.baseUrl + "getEstimatedUnbilledByCustomer/" + customerKey);
  }

  updateInvoiceClientRefNo(data): Observable<any> {
    return this.http.post(this.baseUrl + "updateWoRefPONumber", data);
  }
}

export interface CustomResponse {
  status: "",
  message: "",
  error: "",
  body: any;
}
